import angular from 'angular';

let GroupDetailController = function ($filter, $mdDialog, $scope, $state, Module, Toast, Group) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.group;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,
    isIdInList,
    toggleItemInList
  });

  activate();

  function activate() {
    clearForm();

    loadDomainResources()
      .then(result => {
        _.forEach(result[0], item => {
          item.name = $filter('translate')('shell-' + item.name);
        });
        $ctrl.modules = result[0];

        loadResource($ctrl.id);
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function clearForm(form) {
    $ctrl.group = {
      admin_modules: []
    };

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function handleDelete(group, event) {
    if (group.is_super) {
      Toast.show('Super grupo não pode ser removido');
      return;
    }

    let confirmMessage = group.admin_users.length ? 'group-detail-delete-with-users-confirm-text' : 'group-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Group
          .destroy(group)
          .then(response => {
            Toast.success($filter('translate')('group-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('group.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, group) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    if (!group.admin_modules.length) {
      let confirm = $mdDialog.confirm()
        .textContent($filter('translate')('group-detail-no-access-confirm-text'))
        .ariaLabel($filter('translate')('group-detail-no-access-confirm-text'))
        .targetEvent(event)
        .ok($filter('translate')('common-yes'))
        .cancel($filter('translate')('common-cancel'));

      $mdDialog.show(confirm)
        .then(() => {
          save(group);
        })
        .catch(() => {
        });
    } else {
      save(group);
    }
  }

  function isIdInList(list, id) {
    return _.find(list, {id: id});
  }

  function toggleItemInList(list, item) {
    console.log($ctrl.group.special_rule)
    if (_.find(list, {id: item.id})) {
      _.remove(list, {id: item.id});
    } else {
      list.push(item);
    }
  }

  // Local functions
  function loadResource(id){
    if (id) {
      $ctrl.uiState = 'LOADING';

      Group.show(id)
        .then(response => {
          $ctrl.group = response;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
      $scope.$apply();
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(group) {
    $ctrl.saving = true;

    Group
      .save(group)
      .then(response => {
        Toast.success($filter('translate')('group-detail-save-success'));
        $ctrl.group = response;
        $ctrl.saving = false;
        $state.go('group.list');
      })
      .catch(err => {
        let defaultErrMsg = $filter('translate')('common-server-error');
        let fourONineMsg = $filter('translate')('group-detail-409-error')
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error(message);
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }
}

GroupDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Module', 'Toast', 'Group'];

export default GroupDetailController;



// WEBPACK FOOTER //
// ./client/app/components/group/group-detail.controller.js